export const API_URL = process.env.VUE_APP_API_URL;
export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;


export const PAGE_LIMIT = 25;
